export interface DiffSearchParams {
  highlight?: string;
  /**
   * "Only over threshold" (spec D5) — default ON. 1,912 of 4,338 SKUs used to
   * read as over-threshold every morning; the page's job is the exceptions,
   * so the exception filter is the resting state and opting out is explicit.
   */
  overOnly: boolean;
}

/**
 * Parses TanStack Router's raw search record into typed diff search params.
 * Used as the inventory-diff route's `validateSearch` body. Mirrors
 * `src/features/inventory/lib/url-state.ts`: camelCase keys (the router
 * serializes object keys verbatim), invalid values degrade to the default.
 */
export function parseDiffSearch(raw: Record<string, unknown>): DiffSearchParams {
  const result: DiffSearchParams = { overOnly: parseOverOnly(raw.overOnly) };
  if (typeof raw.highlight === "string" && raw.highlight) result.highlight = raw.highlight;
  return result;
}

function parseOverOnly(v: unknown): boolean {
  if (v === false || v === "false") return false;
  return true;
}
